import React from 'react';
import styled from '@emotion/styled';

const Container = styled.main`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  color: #333;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: var(--primary);
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--secondary);
`;

const Text = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
`;

const List = styled.ul`
  margin-left: 2rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
  line-height: 1.6;
`;

const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <Title>Privacy Policy</Title>
      
      <Section>
        <SectionTitle>Introduction</SectionTitle>
        <Text>
          Welcome to Pop Fidget Toy. This Privacy Policy explains how we collect, use, 
          and protect your information when you visit our website.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Information We Collect</SectionTitle>
        <Text>We collect the following types of information:</Text>
        <List>
          <ListItem>
            <strong>Usage Data:</strong> Information about how you interact with our website, 
            including pages visited and time spent.
          </ListItem>
          <ListItem>
            <strong>Device Information:</strong> Browser type, operating system, and device type.
          </ListItem>
          <ListItem>
            <strong>Cookies:</strong> Small text files stored on your device to enhance your 
            browsing experience.
          </ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>Advertising</SectionTitle>
        <Text>
          We use Google AdSense to display advertisements on our website. Google AdSense uses 
          cookies to serve ads based on your prior visits to our website and other sites on 
          the Internet.
        </Text>
        <Text>
          You can opt out of personalized advertising by visiting 
          <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
            {" "}Google's Ads Settings
          </a>.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Data Usage</SectionTitle>
        <Text>We use your data to:</Text>
        <List>
          <ListItem>Improve our website and user experience</ListItem>
          <ListItem>Analyze website traffic and usage patterns</ListItem>
          <ListItem>Provide personalized advertisements</ListItem>
          <ListItem>Maintain website security</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>Third-Party Services</SectionTitle>
        <Text>
          We use the following third-party services:
        </Text>
        <List>
          <ListItem>Google Analytics for website traffic analysis</ListItem>
          <ListItem>Google AdSense for advertisement display</ListItem>
        </List>
        <Text>
          These services may collect and use your data according to their own privacy policies.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Cookie Policy</SectionTitle>
        <Text>
          Our website uses cookies to enhance your browsing experience and serve personalized advertisements. 
          Types of cookies we use:
        </Text>
        <List>
          <ListItem>
            <strong>Essential Cookies:</strong> Required for the website to function properly
          </ListItem>
          <ListItem>
            <strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website
          </ListItem>
          <ListItem>
            <strong>Advertising Cookies:</strong> Used by Google AdSense to serve personalized ads
          </ListItem>
        </List>
        <Text>
          By using our website, you consent to the use of cookies in accordance with this policy.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Contact Us</SectionTitle>
        <Text>
          If you have any questions about this Privacy Policy, please contact us at:{' '}
          <a href="mailto:exponentialdollar@gmail.com">exponentialdollar@gmail.com</a>
        </Text>
      </Section>

      <Section>
        <SectionTitle>Updates to This Policy</SectionTitle>
        <Text>
          We may update this Privacy Policy from time to time. The latest version will be 
          posted on this page with the effective date.
        </Text>
        <Text>Last updated: March 20, 2024</Text>
      </Section>
    </Container>
  );
};

export default PrivacyPolicy; 